import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import InternalLink from '../../router/InternalLink';
import './ReturnInfoTile.scss';

const ReturnInfoTileLink = (props) => {
    const { linkLocation, returnId, isDeleted, children } = props;

    return (
        !isDeleted &&
        <InternalLink
            elementId={`$link-return-${returnId}`}
            to={linkLocation}
            className='return-info-tile-link'
            useLinkBehavior>
            {children}
        </InternalLink>
    )
}

ReturnInfoTileLink.propTypes = {
    returnId: PropTypes.number,
    isDeleted: PropTypes.bool,
    linkLocation: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
}

export default ReturnInfoTileLink;